<forge-text-field [invalid]="isInvalid" data-lpignore="true" [attr.shape]="forCellEdit ? 'squared' : null"
                  [ngClass]="{'dense-input': dense || compact, 'cell-edit': forCellEdit}" [density]="Density"
                  [required]="isRequired" [attr.label-position]="LabelPosition">
       <input #input type="text" [disabled]="isViewOnly" [name]="Name" id="txt_{{Name}}" [(ngModel)]="valueModel"
              (input)="onInputChange()" (change)="onChange()" [required]="isRequired" [maxlength]="MaxLength"
              [minlength]="MinLength" focusOnLoad [propertyMetadata]="propertyMetadata" [forCellEdit]="forCellEdit" data-lpignore="true"
              (keydown)="enforceFormat($event)" (keyup)="formatToPhone($event)" attr.telemetry="Edit-{{Label}}"
              autocomplete="off" [pattern]="Regex">
       <label for="txt_{{Name}}">{{Label}}</label>
       <span *ngIf="hint && !dense && !compact && !isInvalid" slot="support-text">{{hint}}</span>
       <span *ngIf="isInvalid && !dense && !compact" slot="support-text" class="error-red">{{error}}</span>
       <forge-circular-progress *ngIf="showSpinner" class="metadata-input--spinner" slot="end">
       </forge-circular-progress>
</forge-text-field>
